import { CourseEnrollment } from '../models/courseEnrollment';

export function shouldEnforceCourseOrder(
	categoryEnforcesOrder: boolean | null | undefined,
	enrollmentEnforcesOrder: boolean | null | undefined
): boolean {
	return enrollmentEnforcesOrder === true || categoryEnforcesOrder === true;
}

export function canAccessCourseInOrder(
	courses: CourseEnrollment[],
	courseEnrollmentId: string
): boolean {
	const sortedCourses = [...(courses ?? [])].sort(
		(left, right) => (left?.index ?? 0) - (right?.index ?? 0)
	);
	const coursePosition = sortedCourses.findIndex(course => course?.id === courseEnrollmentId);

	if (coursePosition < 0) return false;
	if (coursePosition === 0 || sortedCourses[coursePosition]?.completedAt) return true;

	return sortedCourses.slice(0, coursePosition).every(course => !!course?.completedAt);
}
